import React, { memo } from "react";
import { MobileLoanType } from "./MobileLoanType";
import { LoanTypeList } from "./LoanTypeList";
import { LoanTypeGrid } from "./LoanTypeGrid";

export const MobileLoanList = memo(
  ({ sortedLoans, isGrid, isComparedIds, setDetails, setComparedId }) => {
    return (
      <div className="loan-types-stack">
        {sortedLoans && sortedLoans.length > 0 ? (
          sortedLoans.map((i) => {
            return isGrid ? (
              <MobileLoanType
                quotes={i.quotes}
                armFixedTermYears={i.armFixedTermYears}
                loanType={i.loanType}
                loanTerm={i.loanTerm}
                key={i.id}
                isComparedIds={isComparedIds}
                setComparedId={setComparedId}
                setDetails={setDetails}
                sortedLoans={sortedLoans}
              />
            ) : (
              <LoanTypeList
                quotes={i.quotes}
                armFixedTermYears={i.armFixedTermYears}
                loanType={i.loanType}
                loanTerm={i.loanTerm}
                key={i.id}
                isComparedIds={isComparedIds}
                setComparedId={setComparedId}
                setDetails={setDetails}
              />
            );
          })
        ) : (
          <div className="empty-state">
            No loans returned with specified parameters. Please try again.
          </div>
        )}
      </div>
    );
  }
);
